import { useQuery } from '@apollo/client';
import { GET_TRIAL_OFFER, type TrialOffer } from '../../graphql/queries/subscriptionPackages';

/**
 * The free trial a new account actually gets, so the sign-up pages only promise one
 * that registration will give. It comes from the brand's trial package alone (the one
 * registration auto-assigns), the single switch for the trial: switched off (as for Cup
 * week) there is no trial and trialDays is null. While loading, `loading` is true and the
 * pages show neutral wording; a failed lookup counts as no trial, never as a made-up one.
 */
export function useTrialOffer(): { trialDays: number | null; loading: boolean } {
  const { data, loading } = useQuery<{ getTrialOffer: TrialOffer | null }>(GET_TRIAL_OFFER, { errorPolicy: 'all' });
  return { trialDays: data?.getTrialOffer?.days ?? null, loading };
}
